import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
import { Injectable } from "@angular/core";

// This impl. bases upon one that can be found in the router's test cases.
@Injectable()
export class CustomReuseStrategy implements RouteReuseStrategy {

	private handlers: { [key: string]: DetachedRouteHandle } = {};

	public shouldDetach(route: ActivatedRouteSnapshot): boolean {
		return true;
	}

	public store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
		this.handlers[route.routeConfig.path] = handle;
	}

	public shouldAttach(route: ActivatedRouteSnapshot): boolean {
		return !!route.routeConfig && !!this.handlers[route.routeConfig.path];
	}

	public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
		if (!route.routeConfig) {
			return null;
		}
		return this.handlers[route.routeConfig.path];
	}

	public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
		return future.routeConfig === curr.routeConfig;
	}

}